import { useCallback, useMemo } from 'react'
import { Network } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchDevices, FRAUD_STR as S, type DeviceRow } from './fraudApi'

/**
 * A25.10 — Связанные аккаунты. Device fingerprints shared by multiple accounts
 * (the multi-account link signal), highest cluster first. Wires the REAL
 * `/admin/antifraud/devices` feed. Placeholder permission USERS_VIEW.
 */
export function LinkedAccountsScreen() {
  const columns = useMemo<AdminColumn<DeviceRow>[]>(
    () => [
      { key: 'id', header: S.fingerprint, type: 'id' },
      { key: 'platform', header: S.platform, type: 'text' },
      { key: 'accounts', header: S.linked, type: 'number' },
      { key: 'flagged', header: S.flagged, type: 'bool' },
      { key: 'first_seen', header: S.firstSeen, type: 'text' },
      { key: 'last_seen', header: S.lastSeen, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchDevices, [])
  return (
    <>
      <PageHeader title={S.linkedAccounts} screenId="A25.10" />
      <DataTable<DeviceRow>
        screenId="A25.10"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => r.id}
        exportable
        emptyState={{ icon: <Network size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
